


















import {Component, Prop, Vue, Watch} from "vue-property-decorator"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import {executeQuery} from "@/data/repos/query"
import AppraisalRiskDrillDown2 from "@/components/widgets/appraisal/AppraisalRiskDrillDown2.vue"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {AppraisalItem, getAppraisalTitlePath} from "@/data/repos/appraisal"
import {bus} from "@/main"
import ModalContainer from "@/components/dialogs/ModalContainer.vue"

@Component({
  components: {
    DataGrid,
    AppraisalRiskDrillDown2,
    ModalContainer,
  },
})
export default class AppraisalLifecyclecostDrillDown extends Vue {
  @Prop() public args!: { locationId: number, aprItem: AppraisalItem, year: number }
  private data: any[] | null = null
  private rawData: any[] | null = null
  public refreshDataGrid: number = 0

  public get title() {
    return "Appraisal costs breakdown - " + getAppraisalTitlePath(this.args.aprItem)
  }

  private get dataGridFields() {
    return [
      {name: "subelementName", title: "Sub element", dataType: DataType.Text, sort: 1},
      {name: "before", title: "Cost before " + this.selectedYear, dataType: DataType.Number, sort: 1},
      {name: "current", title: "Cost in " + this.selectedYear, dataType: DataType.Number, sort: 1},
      {name: "after", title: "Cost after " + this.selectedYear, dataType: DataType.Number, sort: 1},
    ]
  }

  public selectedYear: number | null = null
  public sliderData: number[] | null = null

  @Watch('selectedYear')
  private selectedYearWatcher(v: number) {
    if (v) {
      this.refreshDataGrid++
    }
  }

  public async created() {
    if (this.args.year) {
      this.selectedYear = this.args.year
    }
  }

  public async getData(offset = 0, count?: number) {
    if (offset) {
      return []
    }
    if (!this.rawData) {
      const resp = await this.loadData(this.args.locationId, this.args.aprItem)
      this.rawData = resp || []
    } else {
    }
    this.data = this.filter(this.rawData)
    return this.selectedYear ? this.data : []
  }

  private async loadData(locationId: number, apprItems: any): Promise<any[] | null> {
    const queryName = apprItems.subelementId ? "appraisal.costs.costsDrillDown_subelement" :
      apprItems.elementId ? "appraisal.costs.costsDrillDown_element" :
        apprItems.categoryId ? "appraisal.costs.costsDrillDown_category" :
          apprItems.facetId ? "appraisal.costs.costsDrillDown_facet" :
            apprItems.surveyId ? "appraisal.costs.costsDrillDown_survey" : null
    const args: any = apprItems.subelementId ? {subelementId: apprItems.subelementId} :
      apprItems.elementId ? {elementId: apprItems.elementId} :
        apprItems.categoryId ? {categoryId: apprItems.categoryId} :
          apprItems.facetId ? {facetId: apprItems.facetId} :
            apprItems.surveyId ? {surveyId: apprItems.surveyId} : null
    args.locationId = locationId
    if (queryName) {
      return executeQuery("idr", queryName, args)
    }
    return []
  }

  private setupSlider(years: Set<number>) {
    if (this.sliderData === null) {
      this.sliderData = [...years.values()]
      if (!this.selectedYear) {
        this.selectedYear = this.sliderData[this.sliderData.length - 1]
      }
    }
  }

  private filter(data: any[]): any[] {
    const subElementMap = new Map<String, CostItem>()
    const years: Set<number> = new Set(data.map((v) => v.costs_year).sort())
    const selectedYear = this.selectedYear || new Date().getFullYear()
    this.setupSlider(years)
    for (const item of data) {
      const period = item.costs_year < selectedYear ? "before" :
        item.costs_year === selectedYear ? "current" : "after"
      const existingSubElement = subElementMap.get(item.subelementname)
      if (existingSubElement) {
        const existingPeriodCost = existingSubElement.periods.get(period)
        if (existingPeriodCost) {
          existingSubElement.periods.set(period, existingPeriodCost + item.totalCosts)
        } else {
          existingSubElement.periods.set(period, item.totalCosts)
        }
      } else {
        const periods = new Map([["before", 0], ["current", 0], ["after", 0]])
        periods.set(period, item.totalCosts)
        subElementMap.set(item.subelementname, {
          subelementName: item.subelementname,
          periods,
        } as CostItem)
      }
    }
    const output: any[] = []
    for (const subElementName of [...subElementMap.keys()].sort()) {
      const item = subElementMap.get(subElementName)
      if (item) {
        output.push({
          subelementName: item.subelementName,
          before: formatNumberWithGrouping(item.periods.get("before") || 0, 0),
          current: formatNumberWithGrouping(item.periods.get("current") || 0, 0),
          after: formatNumberWithGrouping(item.periods.get("after") || 0, 0),
        })
      }
    }
    return output
  }

  public close() {
    bus.$emit("modalBoxDestroy")
  }

  public download() {
    const fileDownload = require('js-file-download')
    fileDownload(JSON.stringify(this.rawData), "appraisal-lifcycle-cost.json")
  }
}

interface CostItem {
  subelementName: string,
  periods: Map<string, number>,
}

